import { ILocationState } from './reducer';
import LocationTypes from './types';

export const updateUserLocationState = (payload: ILocationState) => ({
  type: LocationTypes.GET_USER_LOCATION,
  payload,
});
